import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const ResponsibleMedicalRecordSummary = z.object({
  id: z.string(),
  personaInfoSummary: PersonaInfoSummary,
  send: z.string(),
  record: z.string().nullable(),
  completed: z.string().nullable()
})
export type ResponsibleMedicalRecordSummary = z.infer<
  typeof ResponsibleMedicalRecordSummary
>

export const ResponsibleMedicalRecordSummaryList =
  ResponsibleMedicalRecordSummary.array()
export type ResponsibleMedicalRecordSummaryList = z.infer<
  typeof ResponsibleMedicalRecordSummaryList
>
